import axios from 'axios';
import * as urls from './urlTypes';
import * as types from './actionTypes';
import { getClonedPrefrences, setModuleDataOnSave } from '../util/preferenceUtils';
import { toastWarning } from '../util/toastUtils';

export const setLastLocation = location => ({
  type: types.CHANGE_LAST_LOCATION,
  payload: location,
});

export const setAutoUpdateFlag = () => ({
  type: types.AUTO_UPDATE_FLAG,
});

export const setPreferenceFlag = (pageName, flag) => ({
  type: types.SET_PREFERENCE_STUDY_FLAG,
  payload: {
    pageName,
    flag,
  },
});

export function getUserPrefrences(userId, accountId) {
  const url = `${urls.API_GATEWAY_URL}${urls.USER_SERVICE_URL}/user/preference/${accountId}`;
  return (dispatch, getState) => {
    return axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        if (response.data) {
          const clonedPrefernces = getClonedPrefrences(response.data, getState);
          dispatch({
            type: types.SET_PREFERENCES,
            payload: clonedPrefernces,
          });
          dispatch(setModuleDataOnSave(clonedPrefernces));
          return true;
        }
        return false;
      })
      .catch(response => {
        console.warn(response);
        const clonedPrefernces = getClonedPrefrences({});
        dispatch({
          type: types.SET_PREFERENCES,
          payload: clonedPrefernces,
        });
      });
  };
}

export function saveUserPreferences(userId, accountId, preferences) {
  const url = `${urls.API_GATEWAY_URL}${urls.USER_SERVICE_URL}/user/preference/${accountId}`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      data: preferences,
    })
    .then(response => {
      if (response.status === 200) {
        dispatch({
          type: types.SET_PREFERENCES,
          payload: preferences,
        });
        return true;
      }
      toastWarning('Failed to save preferences');
      return false;
    })
    .catch(error => {
      toastWarning('Failed to save preferences');
      console.warn(`error occured saving user preferences ${error}`);
    });
  };
}

